import { render, staticRenderFns } from "./AllLegalDocumentSubmissions.vue?vue&type=template&id=18c628cb&scoped=true&"
import script from "./AllLegalDocumentSubmissions.vue?vue&type=script&lang=js&"
export * from "./AllLegalDocumentSubmissions.vue?vue&type=script&lang=js&"
import style0 from "./AllLegalDocumentSubmissions.vue?vue&type=style&index=0&id=18c628cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c628cb",
  null
  
)

export default component.exports